import type { IInfiniteStaffResponse } from "../../types";

import classes from "./styles.module.scss";

import type { IMetaOption } from "@/interfaces";
import { Avatar } from "@/components/atoms/avatar";
import { Typography } from "@/components/atoms/typography";
import { Icon } from "@/components/atoms/icons";

export function StaffItem(props: IMetaOption<IInfiniteStaffResponse>) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { avatar, facility, first_name, last_name, user_id, value, hf_type } =
    props;

  return (
    <div className={classes.card}>
      <Avatar
        size={"small"}
        userInfo={{
          firstName: first_name,
          lastName: last_name,
          imageUrl: avatar?.url,
        }}
        variant={44}
      />
      <div className={classes.cardText}>
        <div className={classes.cardTopRow}>
          <Typography
            fontWeight={"semi-bold"}
            fontFamily={"dana"}
            fontSize={"md-high"}
          >
            {value}
          </Typography>
          {user_id && (
            <Typography
              fontFamily={"dana"}
              fontSize={"xs"}
              variant={"caption1"}
            >
              {user_id}
            </Typography>
          )}
        </div>
        {facility && (
          <div className={"flex-item-center gap-xs1"}>
            <Icon name={"Hospital"} fontSize={"sm"} color={"secondary-text"} />
            <Typography
              fontFamily={"dana"}
              fontSize={"sm"}
              fontWeight={"regular"}
            >
              {`${hf_type.value} ${facility.value}`}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}
